// extracted by mini-css-extract-plugin
export default {"page":"ProjectsPage_page__liy8H","info_wrapper":"ProjectsPage_info_wrapper__XFEyf","info_card":"ProjectsPage_info_card__so3s4"};